import React from "react";
import { ImageButton } from "components/base/CustomImageButton";
import { CustomTitleWithDropDown } from "components/customer/CustomTitleWithDropDown";
import { useFormContext } from "react-hook-form";
import { connect, useSelector } from "react-redux";
import CloseIcon from 'assets/images/close.svg';
import { CustomTitleLabel } from "components/earning/CustomBaseComponments";

const ReactHookFormMulitSelectDropdown = ({
  title,
  description,
  fieldPrefix = "",
  valueFieldName,
  getSourceDataFromState = () => { },
  defaultValue,
  customClass,
  placeholder,
  defaultFilter,
  loadMoreAction,
  filterAction,
  disabled,
}) => {
  const completeValueFieldName = `${fieldPrefix || ""}${valueFieldName}`
  const { watch, setValue, formState: { errors } } = useFormContext();
  const sourceData = useSelector((state) => getSourceDataFromState(state));

  const fieldValue = watch(completeValueFieldName);


  return (<>
    {title && <CustomTitleLabel title={title} />}
    {description ? (
      <label className="tips-message">{description}</label>
    ) : null}
    {
      !disabled &&
      <CustomTitleWithDropDown
        customClass={customClass}
        title={""}
        description={""}
        source={sourceData}
        placeholder={placeholder}
        labelContainPk
        defaultValue={fieldValue || defaultValue || []}
        setValue={(value) => {
          setValue(completeValueFieldName, value, { shouldDirty: true });
        }}
        loadMoreAction={loadMoreAction}
        filterAction={filterAction}
        defaultFilter={defaultFilter}
        multiple={true}
        toolTips={true}
        notShowLabel={true}
        disableAutoFocus={true}
        customItem={(item) => `[ID: ${item?.pk}] ${item?.name}`}
      />
    }
    <div class="one-group display-brand-group">
      <ul>
        {fieldValue?.map((item) => (
          <li>
            <div class="dot"></div>
            {`[ID: ${item?.value.pk}] ${item?.value.name}`}
            {!disabled &&
              <ImageButton
                image={CloseIcon}
                className={'close2'}
                action={() => {
                  setValue(
                    completeValueFieldName,
                    fieldValue.filter(
                      (v) => v.value.pk !== item.value.pk,
                    ),
                    { shouldDirty: true },
                  );
                }}
              />}
          </li>
        ))}
      </ul>
    </div>
  </>)

}

const mapPropsToState = (state) => ({
});

export default connect(mapPropsToState)(ReactHookFormMulitSelectDropdown);